<template>
  <!-- 签到 -->
  <div class="mar-top">
    <back-route-hdr :back-mode="'func'" @handle-back="closePage()"></back-route-hdr>

    <div v-if="mDoc.subject" class="bg-white pad-all-10 mar-hor checkin-box">
      <div class="checkin-icon">
        <van-button v-show="iconInfo.icon" :type="iconInfo.type" round>
          <i :class="iconInfo.icon" aria-hidden="true"></i>
        </van-button>
        <van-button v-show="iconInfo.text" :type="iconInfo.type" square>{{iconInfo.text}}</van-button>
      </div>

      <h3 class="text-center pad-top pad-btm-10">
        <span>{{cellData.subject}}</span>
      </h3>
      <van-cell-group class="mar-btm">
        <van-cell v-show="cellData.roomNum" :title="cellData.roomNum" icon="location-o"></van-cell>

        <van-collapse v-if="cellData.teleconferenceType==='created'" v-model="tlcActName">
          <van-collapse-item :name="statusPermit? '1' : '0'" icon="tv-o" class="bord-btm" :disabled="!ownPermit">
            <template #title>
              <div>
                <tlc-logo :tlc-manufacturer="cellData.tlcManufacturer"></tlc-logo>
                <span> {{cellData.conferenceNum}}</span>
              </div>
            </template>
            <tlc-invitation :m-doc="mDoc"
                            :teleconference-info="cellData.teleconferenceInfo"
                            :reserved-permit="reservedPermit"
                            :status-permit="statusPermit"></tlc-invitation>
          </van-collapse-item>
        </van-collapse>

        <van-cell v-if="cellData.teleconferenceType==='related'"
                  :title="'视频会议号 - ' + cellData.conferenceNum" icon="tv-o"></van-cell>

        <van-cell :title="'开始时间 - '+cellData.startDate+' '+cellData.startTime" icon="clock-o"></van-cell>
        <van-cell :title="'结束时间 - '+cellData.endDate+' '+cellData.endTime" icon="underway-o"></van-cell>

        <van-cell :title="sysFormTitles.sponsor+' - '+ cellData.sponsorName" icon="manager-o"></van-cell>

        <!--<div v-if="cellData.participants.length>1">
          <van-cell v-show="cellData.participants.length!==cellData.numberOfPeople"
                    :title="'参会人数 - '+ cellData.numberOfPeople" icon="friends-o"></van-cell>
          <van-cell :title="'参会人（'+(cellData.insideParticipant||[]).length+'）'" icon="friends-o">
            <template #label>
              <div class="participants-ctn">
                <span v-for="(e) in cellData.participants">
                  {{e.name}}
                  <i v-show="e.checkedIn" class="fa fa-check"></i>
                </span>
              </div>
            </template>
          </van-cell>
        </div>
        <div v-else-if="cellData.participants.length">
          <van-cell icon="contact">
            <template #title>
              <span>参会人（{{cellData.participants.length}}）- {{cellData.participants[0].name}}</span>
            </template>
          </van-cell>
        </div>
        <van-cell :title="'外部参会人（'+(cellData.outsideParticipant||[]).length+'）'" icon="friends-o"
                  v-show="cellData.visitors" :label="cellData.visitors"></van-cell>-->
        <!--<van-cell v-show="cellData.checkinDate" :title="'会议已签到 - '+ cellData.checkinBy"-->
        <van-cell icon="label-o" v-show="cellData.shouldAttendance > 1 || cellData.actualAttendance > 1">
          <template>
            <span>
              应到 {{cellData.shouldAttendance}} 人，
              实到 {{cellData.actualAttendance}} 人，
              签到率 {{cellData.attendanceRate}}%
            </span>
          </template>
        </van-cell>
        <van-cell v-show="cellData.checkinDate" title="会议已签到"
                  :value="cellData.checkinDate" icon="certificate"></van-cell>
        <van-cell v-show="totalRecodes" icon="sign">
          <template #title>
            <span>已签到人（{{totalRecodes}}）</span>
            <span class="pull-right text-sm" @click="handleChkDetail">
              查看签到详情 <i class="fa fa-angle-right"></i></span>
          </template>
          <template #label>
            <div class="participants-ctn">
              <span v-for="(e) in shortCheckRecodes">{{e.name}}</span>
              <span v-if="totalRecodes>20">......</span>
            </div>
          </template>
        </van-cell>
        <van-cell v-show="endedTime" title="手动结束时间" icon="stop-circle-o" :value="endedTime"></van-cell>
        <van-cell v-show="iconInfo.text" title="会议即将开始 - 会议结束前，可进行签到" icon="info-o"></van-cell>
      </van-cell-group>

      <div class="pad-btm-10" v-show="showCheckinBtn">
        <van-button type="primary" block size="small" @click="handleCheckin">签到</van-button>
      </div>
    </div>
    <div v-else class="bg-white mar-hor">
      <empty-notice :desc="'当前会议不存在'"></empty-notice>
    </div>

    <div class="mar-all">
      <van-button v-show="deviceIds.tlc" block size="small"
                  class="mar-btm" plain type="info" @click="sendCmd('clickJoinMeeting')">
        {{controlBtnMap.clickJoinMeeting}}
      </van-button>

      <van-button v-show="deviceIds.door" block size="small" class="mar-btm" plain type="warning"
                  @click="sendCmd('checkinUnlock')">{{controlBtnMap.checkinUnlock}}
      </van-button>

      <van-button block size="small" class="mar-btm" :plain="!mDoc.isUserCheckin" type="primary"
                  @click="handleMtDetail">查看会议详情 >
      </van-button>
    </div>

    <!--<p class="text-center text-underline pad-top pad-btm-20" @click="handleReserve">预约会议 ></p>-->
  </div>
</template>

<script>
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {meeting, meetingRoom, checkRecode} from "../../../../server"
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import {commonConfig, momentFormat} from "../../../../config/common"
  import {
    checkIsWXWork,
    checkRespCorrect,
    checkShowPermit,
    formatMtDetail,
    frontConfirm,
    initWeiTalkJsBridge,
    queryTlcInfoByKey
  } from "../../../../tools/utils"
  import routerMeta from "../../router/routerMeta"
  import TlcLogo from "../../components/TlcLogo"
  import TlcInvitation from "../../components/TlcInvitation"

  const iconStatusStyle = {
    GOINGTOSTART: 'default',
    MEETING: 'default',
    NOTSTART: 'info',
    END: 'info',
    CANCELED: 'danger',
  };

  const btnMapKeys = {
    clickJoinMeeting: "clickJoinMeeting",
    checkinUnlock: "checkinUnlock",
  };

  export default {
    components: {
      // 视频会议相关组件
      TlcInvitation,
      TlcLogo,
    },
    data() {
      return {
        mid: "",
        mDoc: {},
        tlcActName: [],
        checkRecodes: [],
        totalRecodes: 0,
        // pageInfo: {
        //   pageSize: 10,
        //   pageNum: 1,
        //   pages: 1,
        // },
        // finished: false,
        // loading: false,
      }
    },
    computed: {
      sysFormTitles() {
        return this.$store.state.formTitles
      },
      controlBtnMap() {
        return {
          clickJoinMeeting: this.sysFormTitles.clickJoinMeeting,
          checkinUnlock: this.sysFormTitles.checkinUnlock,
        }
      },
      // 生成签到数据
      userId() {
        return this.$store.state.userId || getStorage(StorageKey.userId)
      },
      permissionList() {
        return this.$store.state.permissionList || []
      },
      meetingStatus: function () {
        return this.$store.state.meetingStatus
      },
      cellData() {
        // if (!meetingRooms.length) return {};
        return formatMtDetail(this.mDoc, this)
      },
      endedTime: function () {
        const finishedAt = this.mDoc.finishedInfo && this.mDoc.finishedInfo.date;
        if (this.mDoc.status === commonConfig.meetingStatus.END && finishedAt) {
          return moment(finishedAt).format(momentFormat.dateFormatMonthDetailCN)
        }
      },
      iconInfo: function () {
        const {status, isUserCheckin} = this.mDoc;
        if (isUserCheckin) {
          return {
            icon: "fa fa-check",
            type: "primary",
          }
        }
        if (commonConfig.checkinStatus.includes(status)) {
          return {
            icon: "fa fa-calendar-o",
            type: "default",
          }
        }
        return {
          text: this.meetingStatus[status],
          type: iconStatusStyle[status],
        }
      },
      deviceIds: function () {
        if (this.ownPermit && commonConfig.checkinStatus.includes(this.mDoc.status)) {
          const {teleconferenceInfo: tlcInfo, doorDeviceId} = this.mDoc;
          return {
            tlc: checkShowPermit(this.permissionList, this.permitsMap.clickJoinMeeting) && tlcInfo && tlcInfo.tlcDeviceId,
            door: checkShowPermit(this.permissionList, this.permitsMap.checkinUnlock) && doorDeviceId
          }
        }
        return {}
      },
      statusPermit: function () {
        return commonConfig.normalStatus.includes(this.mDoc.status)
      },
      reservedPermit: function () {
        const selfReserved = this.mDoc.reservedBy && this.mDoc.reservedBy.userId === this.userId;
        return selfReserved && this.statusPermit
      },
      ownPermit: function () {
        return (this.mDoc.insideParticipant || []).concat(this.mDoc.reservedBy || {}).some(e => e.userId === this.userId)
      },
      showCheckinBtn: function () {
        // const {checkinInfo, insideParticipant} = this.mDoc;
        // const cPrt = (insideParticipant || []).find(e => e.userId === this.userId);
        const {meetingRooms = []} = this.mDoc;
        return meetingRooms.length && !this.mDoc.isUserCheckin && this.iconInfo.icon
      },
      shortCheckRecodes: function () {
        return this.checkRecodes.splice(0, 20)
      },
    },
    created() {
      this.mid = this.$route.params.mid;
      this.initMDoc();
    },
    methods: {
      // 获取会议信息
      initMDoc() {
        !this.mDoc.subject && UILoader.load();
        meeting.queryDetail(this, {
          queryFilter: {
            selfCursor: this.mid,
            getIsUserCheckin: true
          }
        }).then(({searchMeeting: data = {}}) => {
          UILoader.unload();
          const [edge] = (data.meetingEdges || []);
          if (edge && edge.cursor === this.mid && edge.meeting) {
            this.mDoc = edge.meeting;
            this.mDoc.mid = edge.cursor;
          } else {
            vtToast("会议不存在")
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
        this.getCheckRecodes();
      },
      // 获取签到记录
      getCheckRecodes() {
        checkRecode.queryList(this, {
          queryFilter: {
            pageNum: 1,
            pageSize: 20,
            mid: this.mid
          }
        }).then(({searchCheckinRecord: data = {}}) => {
          const {records = [], pageInfo} = data;
          this.checkRecodes = records;
          this.totalRecodes = pageInfo.total;
        }).catch(err => {
          vtToast(err.message)
        })
      },
      handleReserve() {
        this.$router.push({name: routerMeta.meetingReserveFromHome.name});
      },
      handleMtDetail() {
        this.$router.push({name: routerMeta.meetingDetailFromHome.name, params: {mid: this.mid}});
      },
      handleChkDetail() {
        this.$router.push({name: routerMeta.checkinRecordList.name, params: {mid: this.mid}});
      },
      handleCheckin() {
        // 非参会人也可签到
        this.submitCheckin();
        /*const {insideParticipant = []} = this.mDoc;
        if (insideParticipant.some(e => e.userId === this.userId)) {
          this.submitCheckin();
          return
        }
        frontConfirm({msg: "您不是此会议的参会人，是否确认签到？"}, () => {
          this.submitCheckin();
        })*/
      },
      // 提交签到
      submitCheckin() {
        UILoader.load("签到中...");
        meeting.checkInMeeting(this, {mid: this.mid}).then(({checkInMeeting: resp = {}}) => {
          // UILoader.unload();
          if (checkRespCorrect(resp, "签到失败")) {
            vtToast('签到成功');
            this.initMDoc()
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      async sendCmd(type) {
        // const {status, checkinInfo} = this.mDoc;
        // if (status !== commonConfig.meetingStatus.MEETING && (!checkinInfo || !checkinInfo.date)) {
        //   // 入会、开锁
        //   vtToast(`签到后可${this.controlBtnMap[type]} ~`);
        //   return
        // }
        let tip = "";
        let data;
        switch (type) {
          case btnMapKeys.clickJoinMeeting:
            tip = `是否确认加入视频会议 ${this.cellData.conferenceNum}？`;
            const tlcInfo = await queryTlcInfoByKey.call(this, ['conferenceNum', 'password'], this.mDoc.mid);
            data = {
              deviceId: this.deviceIds.tlc || '',
              roomId: this.cellData.roomId,
              branchVenuesIds: this.cellData.branchVenues && this.cellData.branchVenues.map(ele => ele.id),
              method: "callJoin",
              params: JSON.stringify({
                number: tlcInfo && tlcInfo.conferenceNum || '',
                password: tlcInfo && tlcInfo.password || '',
              })
            };
            break;
          case btnMapKeys.checkinUnlock:
            tip = "是否确认开锁？";
            data = {
              deviceId: this.deviceIds.door,
              roomId: this.cellData.roomId,
              method: "setDoorUnLock",
            };
            break;
          default:
            return;
        }

        frontConfirm({msg: tip}, () => {
          UILoader.load("执行中...");
          meetingRoom.sendCommand(this, {data: data}).then(({sendCommand: resp = {}}) => {
            if (checkRespCorrect(resp, "控制失败")) {
              messageHdl({code: msgCode.SUCCESS, msg: "发送成功"});
            }
          }).catch(err => {
            messageHdl({msg: err.message})
          })
        })
      },
      closePage() {
        try {
          // 企业微信、微信
          if ((checkIsWXWork() || checkIsWXWork()) && WeixinJSBridge) {
            WeixinJSBridge.call('closeWindow');
            return;
          }
          // WeiTalk
          if (getStorage(StorageKey.mobJsBridge) === commonConfig.weichai) {
            initWeiTalkJsBridge(function () {
              if (window.WebViewJavascriptBridge) {
                window.WebViewJavascriptBridge.callHandler('closePage', {
                  "apptag": "ezLink"
                })
              } else {
                vtToast("initJsBridge failed.");
              }
            });
            return;
          }
        } catch (e) {
          vtToast(e.message);
        }
        window.location.replace(window.location.origin + window.location.pathname);
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../styles/variable.less";

  .checkin-box {
    margin-top: 45px;
  }

  .checkin-btn-group > .buttons-container {
    .snd-padding {
      padding: 8px 65px !important;
    }

    ul li {
      box-shadow: unset;
    }
  }

  .checkin-icon {
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    text-align: center;

    .van-button--round {
      height: 64px;
      width: 64px;
      border: 5px solid @body-bg;
      font-size: 22px;
      margin: 0 auto;
    }

    .van-button--square {
      margin-top: 10px;
      border: 5px solid @body-bg;
      border-radius: 999px;
      width: 100px;
      height: 50px;
    }

    .van-button--info {
      background-color: @font-color-lt;
    }

    .van-button--default {
      color: @warning-color;
    }
  }
</style>
